// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"7654d4c6","703":"775fa644","787":"be83245f"}[chunkId] + ".chunk.js";
};